export const TRANSLATIONS_DE = {
  username: "Benutzername",
  password: "Passwort",
  login: "ANMELDEN",
  registerMsg: "Noch nicht registriert?",
  registerMsg2: "Klicken Sie hier",
  modalMsg: "Falsches Passwort und/oder Benutzername",
};
